// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconXlayer } from "../../../icons/full/build/icon-xlayer.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const XlayerIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconXlayer.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  XlayerIcon.displayName = 'XlayerIcon';
}

export default XlayerIcon;